import objectAssign from '../node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js';

var assign = objectAssign;

export { assign as default };
//# sourceMappingURL=index.js_commonjs-proxy2.js.map
